export default __webpack_public_path__ + "static/media/vesky.ac8504e9.PNG";